import { Link } from 'react-router-dom';

const sections = [
  {
    title: '協会について',
    subtitle: 'About OMFES',
    description: '2025年に設立された一般社団法人東洋医学未来推進協会（OMFES）。設立の趣旨、代表挨拶、役員一覧についてご案内します。',
    path: '/about',
    icon: 'ri-building-line',
  },
  {
    title: '活動内容',
    subtitle: 'Activities',
    description: '学術大会への参加・展示をはじめ、業界連携、普及広報活動、勉強会・フォーラムなど、多岐にわたる活動を推進しています。',
    path: '/activities',
    icon: 'ri-calendar-event-line',
  },
  {
    title: '入会・協賛',
    subtitle: 'Join & Sponsor',
    description: '東洋医学の発展と普及に賛同いただける企業・団体・個人の皆様の参加をお待ちしております。入会案内・協賛情報はこちら。',
    path: '/membership',
    icon: 'ri-group-line',
  },
];

export default function MissionSection() {
  return (
    <section className="bg-cream-100 py-24 md:py-32 relative overflow-hidden">
      {/* Decorative background ripple */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 w-96 h-96 rounded-full border border-forest-600/8 pointer-events-none" />
      <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 w-64 h-64 rounded-full border border-forest-600/8 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Section header */}
        <div className="text-center mb-16 md:mb-20">
          <div className="inline-block border border-forest-600/30 px-6 py-1.5 mb-6">
            <span className="text-forest-600 text-xs font-serif tracking-widest2">OUR MISSION</span>
          </div>
          <h2 className="text-forest-800 font-serif font-light text-3xl md:text-4xl tracking-wider leading-snug mb-4">
            東洋医学の価値を社会に、<br className="hidden md:block" />持続可能な未来を共に
          </h2>
          <p className="text-forest-600/70 text-sm font-serif max-w-xl mx-auto leading-relaxed">
            学術・臨床・産業の垣根を越え、東洋医学の新たな可能性を創出します
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {sections.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="group block bg-white border border-cream-300 rounded-sm p-8 hover:bg-forest-700 transition-all duration-400 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center border border-forest-600/30 group-hover:border-cream-400/40 mb-6 transition-colors duration-400">
                <i className={`${item.icon} text-forest-600 group-hover:text-cream-300 text-lg transition-colors duration-400`} />
              </div>
              <p className="text-forest-500/60 group-hover:text-cream-400/60 text-xs font-serif tracking-widest mb-2 transition-colors duration-400">
                {item.subtitle}
              </p>
              <h3 className="text-forest-800 group-hover:text-cream-100 font-serif font-medium text-xl tracking-wider mb-4 transition-colors duration-400">
                {item.title}
              </h3>
              <p className="text-forest-600/70 group-hover:text-cream-300/80 text-sm font-serif leading-relaxed mb-6 transition-colors duration-400">
                {item.description}
              </p>
              <span className="text-forest-600 group-hover:text-cream-300 text-xs font-serif tracking-widest flex items-center gap-2 transition-colors duration-400">
                詳しく見る
                <i className="ri-arrow-right-line text-sm" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
